export const AUTHORIZE = 'AUTHORIZE';
export const UNAUTHORIZE = 'UNAUTHORIZE';
export const SET_TWO_STEP_AUTHORIZATION_DATA = 'SET_TWO_STEP_AUTHORIZATION_DATA';

export const FINISH_LOADING = 'FINISH_LOADING';
export const START_LOADING = 'START_LOADING';

export const UPDATE_ACTIVATION_DATA = 'UPDATE_ACTIVATION_DATA';

export const SET_SERVER_ERROR_STATUS = 'SET_SERVER_ERROR_STATUS';
